/**
 * Created by Wang.Qiong on 2021/10/13.
 */
import React from "react";
import { Modal, Input, Button, Table, Steps, message } from 'antd';
import { progressQuery } from '../../utils/api'
const { Step } = Steps;
class queryProgress extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            idno: '',
            message: '',
            progressArr: [
                { start: ['待审核', '已受理', '已驳回'], message: '您当前的申请进度为"资格预审",当前节点审核责任主体为奉贤区公租房公司,对应的申请状态为', title: '资格预审' },
                { start: ['已复核'], message: '您当前的申请进度为"资格复审",当前节点审核责任主体为奉贤区公租房公司,对应的申请状态为', title: '资格复审' },
                { start: ['已上传大机', '未通过', '已通过'], message: '您当前的申请进度为"资格终审",当前节点审核责任主体为市、区两级住房保障部门,对应的申请状态为', title: '资格终审' },
                { start: ['排队中', '排队成功', '排队失效', '排队过号', '预约中', '预约成功', '预约失效'], message: '您当前的申请进度为"房源轮候",对应的申请状态为', title: '房源轮候' },
                { start: ['已预签'], message: '您当前的申请进度为"合同打印",对应的申请状态为', title: '合同打印' },
                { start: ['已签约'], message: '您当前的申请进度为"入住登记",对应的申请状态为', title: '入住登记' }],
            active: -1,
        }

    }
    handleCancel = e => {
        this.setState({
            visible: false,
            idno: '',
            active: '',
            message: ''
        });
    };
    showQueryProgress = async () => {
        this.setState({
            visible: true,
        });
    }
    getProgressQuery = async () => {
        let opt = {
            idno: this.state.idno
        }
        let obj = await progressQuery(opt)
        if (obj.code === 0) {
            let message = obj.data
            let active = 0
            if (message !== '暂无申请进度') {
                const { progressArr } = this.state
                for (var i = 0; i < progressArr.length; i++) {
                    for (var j = 0; j < progressArr[i].start.length; j++) {
                        if (progressArr[i].start[j] === message) {
                            message = progressArr[i].message + '"' + message + '"'
                            active = i
                        }
                    }
                }
                this.setState({
                    message: message,
                    active: active
                })
            } else {
                this.setState({
                    message: message,
                    active: -1
                })

            }
        } else {
            message.error(obj.message)
        }
    }

    setValue = (n, e) => {
        const value = e.target ? e.target.value : e;
        let obj = {};
        obj[n] = value
        this.setState({
            ...obj
        });
    }
    getSearch = () => {
        this.setState({
            message: '',
            active: -1
        })
        this.getProgressQuery()
    }
    render() {
        const { visible, message, progressArr, active } = this.state

        return (
            <div>
                {visible ? <Modal
                    title="申请进度查询"
                    centered
                    visible={visible}
                    onCancel={this.handleCancel}
                    width={1000}
                    footer={[]}
                    className="queryProgress"
                >
                    <div className="homeModelHeader">
                        <Input placeholder="请输入身份证" style={{ margin: '0 20px 10px 5px', width: '200px' }} onBlur={this.setValue.bind(this, 'idno')} />
                        <Button type="primary" htmlType="button" onClick={() => tapOnce(this.getSearch, null)}>
                            搜索
                        </Button>
                    </div>
                    <Steps size="small" current={active} >
                        {progressArr.map((item, index) => {
                            return (
                                <Step key={index} title={item.title} />
                            )
                        })}
                    </Steps>
                    {/* <Steps size="small" current={2} >
                        {progressArr.map((item, index) => {
                            return (
                                <Step key={index} title={item} />
                            )
                        })}
                    </Steps> */}
                    <div style={{ color: '#3651a9', padding: '10px' }}>{message}</div>
                </Modal> : null}

            </div>
        )
    }
    tableModel = (item, index) => {
        return (
            {
                key: index,
                index: index + 1,
                name: item.username,
                numbering: item.transactionNo,
                circumstance: item.checkReason,
            }
        );
    }
    // tableModel = (item, index) => {
    //     return (
    //         <li key={index}>
    //             <span className="username">
    //                 {item.username}
    //             </span>
    //             <span className="telephone">
    //                 {item.telephone}
    //             </span>
    //         </li>
    //     );
    // }
}
export default queryProgress;
